import { withHandlers } from 'recompose';

const enhancer = withHandlers({
  onClick: ({ onClick, index }) => () => {
    onClick && onClick(index);
  },
});

export default enhancer;
